
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topbusinessquotes/[category]",
      function () {
        return require("private-next-pages/topbusinessquotes/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topbusinessquotes/[category]"])
      });
    }
  